<template>
  <div :class="{ conversion: isConversion, default: !isConversion }">
    <div class="runner">ランナー</div>
    <div class="name font-english">NAME</div>
    <div id="js-runner-name" class="runner-name">
      {{ dataRunner.certificate_ranking.runner_name }}
    </div>
    <div class="team-name">
      {{ dataRunner.certificate_ranking.team_name }}
    </div>
    <div class="record">
      <div class="item-area">
        <div class="item-ja">{{ recordTitleJa }}</div>
        <div class="item-en font-english">{{ recordTitleEn }}</div>
      </div>
      <div class="finish-time">{{ recordValue }}</div>
      <div class="item-area">
        <div class="item-ja">総合ランキング</div>
        <div class="item-en font-english">OVERALL PLACE</div>
      </div>
      <div class="finish-ranking">
        {{ dataRunner.certificate_ranking.total_ranking }}位&nbsp;<span
          class="participants"
          >/{{ dataRunner.certificate_ranking.total_runner_count }}人中</span
        >
      </div>
    </div>
    <div class="category">
      <div
        class="category-item"
        v-for="(rankingItem, index) of dataRunner.certificate_ranking
          .certificate_ranking_items"
        :key="index"
      >
        <div class="category-item-area">
          <div class="category-item-area-lang">
            <div class="ja">{{ rankingItem.detail_item.ja }}</div>
            <div class="en font-english">{{ rankingItem.detail_item.en }}</div>
          </div>
          <div class="category-item-area-lang-detail">
            <div class="ja">
              {{ rankingItem.detail.ja }}
            </div>
            <div class="en font-english">
              {{ rankingItem.detail.en }}
            </div>
          </div>
        </div>
        <div class="ranking-area">
          {{ rankingItem.ranking }}位
          <span class="number-of-participants"
            >/{{ rankingItem.runner_count }}人中
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.certificateWidth === 1000
      ? document
          .getElementById("js-runner-name")
          .classList.remove("multiple-lines-font")
      : document
          .getElementById("js-runner-name")
          .classList.remove("dw-multiple-lines-font");
    const textLength =
      document.getElementById("js-runner-name").innerText.length;

    if (textLength > 20) {
      this.certificateWidth === 1000
        ? document
            .getElementById("js-runner-name")
            .classList.add("multiple-lines-font")
        : document
            .getElementById("js-runner-name")
            .classList.add("dw-multiple-lines-font");
    }
  },
  props: {
    isConversion: Boolean,
    isCompany: Boolean,
    certificateWidth: Number,
    distanceLimitFlg: [Number, null],
    dataRunner: Object,
  },
  computed: {
    isDistanceRecord: function () {
      return this.distanceLimitFlg === 0;
    },
    recordTitleJa: function () {
      return this.isDistanceRecord ? "総走行距離" : "フィニッシュタイム";
    },
    recordTitleEn: function () {
      return this.isDistanceRecord ? "TOTAL DISTANCE" : "TIME *uncertified";
    },
    recordValue: function () {
      return this.isDistanceRecord
        ? this.dataRunner.certificate_ranking.total_distance
        : this.dataRunner.certificate_ranking.total_time;
    },
  },
  name: "PersonalRanking",
};
</script>

<style scoped lang="scss">
$certificate-color: #c9ba87;
$sub-certificate-color: #a8985f;
.font-english {
  font-family: "EB Garamond", sans-serif;
}

/** 1000 */
.default {
  .runner {
    margin: 2.5% 0 0 0;
    font-size: 1.2em;
    font-weight: bold;
    color: $sub-certificate-color;
  }

  .name {
    font-size: 1em;
    color: $sub-certificate-color;
  }

  .runner-name {
    display: inline-flex;
    align-items: center;
    max-width: 73%;
    height: 50px;
    line-height: 1.5;
    border-bottom: 1px solid $certificate-color;
    /*2行になったら1em jsで対応*/
    font-size: 2.2em;
    font-weight: bold;
    overflow: hidden;
  }

  .team-name {
    font-size: 1em;
    font-weight: bold;
    color: #a8985f;
    height: 18px;
    margin: 10px 0px 0px 0px;
  }

  .multiple-lines-font {
    font-size: 1em;
  }

  .record {
    margin: 10px 10% 0 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      border-left: solid 2px $sub-certificate-color;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 1.2em;
        font-weight: bold;
      }

      .item-en {
        font-size: 0.8em;
      }
    }

    .finish-time,
    .finish-ranking {
      font-size: 2em;
      font-weight: bold;

      .participants {
        font-size: 0.5em;
      }
    }
  }

  .category {
    margin: 3.5% 7% 0 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;

    .category-item {
      flex: 1;

      .category-item-area {
        display: flex;
        color: $sub-certificate-color;

        .category-item-area-lang {
          min-width: 160px;
          padding: 0 0 0 4%;
          border-left: solid 2px $sub-certificate-color;

          .ja {
            font-size: 1em;
            font-weight: bold;
          }

          .en {
            font-size: 0.6em;
          }
        }

        .category-item-area-lang-detail {
          min-width: 90px;
          margin: 0 0 0 4%;
          white-space: nowrap;

          .ja {
            font-size: 1em;
            font-weight: bold;
          }

          .en {
            font-size: 0.6em;
          }
        }
      }

      .ranking-area {
        margin: 4% 0 0 0;
        padding: 0 0 0 4%;
        flex: 1;
        font-size: 1.4em;
        font-weight: bold;

        .number-of-participants {
          font-size: 0.625em;
        }
      }
    }
  }
}

/** 4000 */
.conversion {
  .runner {
    margin: 2.5% 0 0 0;
    font-size: 70px;
    font-weight: bold;
    color: $sub-certificate-color;
  }
  .name {
    font-size: 60px;
    color: $sub-certificate-color;
  }
  .runner-name {
    display: inline-flex;
    align-items: center;
    max-width: 3000px;
    height: 240px;
    line-height: 1.5;
    border-bottom: 4px solid $certificate-color;
    /*2行になったら66px jsで対応*/
    font-size: 150px;
    font-weight: bold;
    overflow: hidden;
  }
  .team-name {
    font-size: 60px;
    font-weight: bold;
    color: #a8985f;
    height: 18px;
    margin: 30px 0px 0px 0px;
  }
  .dw-multiple-lines-font {
    font-size: 66px;
  }
  .record {
    margin: 3.5% 13% 0 13%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      border-left: solid 2px $sub-certificate-color;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 70px;
        font-weight: bold;
      }

      .item-en {
        margin: 10px 0 0 0;
        font-size: 50px;
      }
    }

    .finish-time,
    .finish-ranking {
      font-size: 150px;
      font-weight: bold;

      .participants {
        font-size: 60px;
      }
    }
  }
  .category {
    margin: 2.8% 11% 0 13%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    .category-item {
      flex: 1;
      .category-item-area {
        display: flex;
        color: $sub-certificate-color;
        .category-item-area-lang {
          min-width: 600px;
          padding: 0 0 0 4%;
          border-left: solid 2px $sub-certificate-color;
          .ja {
            font-size: 60px;
            font-weight: bold;
          }
          .en {
            font-size: 40px;
          }
        }
        .category-item-area-lang-detail {
          min-width: 350px;
          margin: 0 0 0 4%;
          white-space: nowrap;
          .ja {
            font-size: 60px;
            font-weight: bold;
          }
          .en {
            font-size: 40px;
          }
        }
      }
      .ranking-area {
        margin: 4% 0 0 0;
        padding: 0 0 0 4%;
        flex: 1;
        font-size: 80px;
        font-weight: bold;
        .number-of-participants {
          font-size: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PersonalRanking.vue